import React from 'react';
import LabelWithInfo from 'modules/shared/components/label-with-info';
import t from 'utils/translate';
import { selectCompanySettings, selectDataLoaded } from 'modules/settings/stores/company-settings-slice-handler';
import { selectSettingsJson, updateJsonSetting } from 'modules/settings/stores/user-settings-slice-handler';
import { useSelector } from 'react-redux';
import { DISTANCE_UNIT } from 'constants/user-settings';
import SelectInput from 'modules/shared/components/select-input';
import { MenuItem } from '@mui/material';
import ActiveInactiveSelector from './active-inactive-selector';

function SectionGeolocationMap() {
    const dataLoaded = useSelector(selectDataLoaded);
    /**
     * @type {CompanySettings}
     */
    const companySettings = useSelector(selectCompanySettings);
    /**
     * @type {UserSettingsJson}
     */
    const settingsJson = useSelector(selectSettingsJson);

    if (!dataLoaded || !companySettings.IsDispatcher) {
        return;
    }

    return (
        <div className="settings-section" data-test-id="geolocation-map">
            <div className="settings-section-title">
                <LabelWithInfo text={t('menu_geolocation')} />
                <div className="strike" />
            </div>
            <div className={'section-content'}>
                <div className="section-row" data-test-id={`distance-unit`}>
                    <LabelWithInfo
                        text={t('settings_dispatch_console_distance_unit_title')}
                        info={t('settings_dispatch_console_distance_unit_tooltip')}
                        tooltipPlacement="right"
                    />
                    <SelectInput
                        className="info-field-dropdown"
                        value={settingsJson.distanceUnit}
                        data-test-id="select-distance-unit"
                        handleChange={(e) => {
                            updateJsonSetting(
                                'distanceUnit',
                                e.target.value,
                                t('menu_geolocation'),
                                t('js_all_distance_unit_changed_successfully'),
                            );
                        }}
                    >
                        <MenuItem value={DISTANCE_UNIT.METER}>{t('dispatch_console_distance_unit_meter')}</MenuItem>
                        <MenuItem value={DISTANCE_UNIT.YARD}>{t('dispatch_console_distance_unit_yard')}</MenuItem>
                    </SelectInput>
                </div>

                <div className="section-row" data-test-id={`geolocation-notification`}>
                    <LabelWithInfo
                        text={t('settings_geolocation_notification')}
                        info={t('settings_geolocation_notification_tooltip')}
                        tooltipPlacement="right"
                    />
                    <ActiveInactiveSelector
                        initialValue={settingsJson.geolocationNotification}
                        onChange={(v) => {
                            updateJsonSetting(
                                'geolocationNotification',
                                v,
                                t('menu_geolocation'),
                                t('js_all_settings_geolocation_notifications_changed_successfully'),
                            );
                        }}
                    ></ActiveInactiveSelector>
                </div>
                {!!settingsJson.geolocationNotification && (
                    <div className="section-row" data-test-id={`geolocation-notification-on-map`}>
                        <LabelWithInfo
                            text={t('settings_geolocation_notify_status_changes')}
                            info={t('settings_geolocation_notify_status_changes_tooltip')}
                            tooltipPlacement="right"
                        />
                        <ActiveInactiveSelector
                            initialValue={settingsJson.displayNotificationOnGeolocationMap}
                            onChange={(v) => {
                                updateJsonSetting(
                                    'displayNotificationOnGeolocationMap',
                                    v,
                                    t('menu_geolocation'),
                                    t('js_all_settings_geolocation_notify_status_changes_changed_successfully'),
                                );
                            }}
                        ></ActiveInactiveSelector>
                    </div>
                )}
            </div>
        </div>
    );
}
export default SectionGeolocationMap;
